export const SG_CONVENIENCE: string = 'SGCONV';
export const SG_CONSUMER: string = 'SGCONS';
export const SG_JAVA: string = 'SGJAVA';
export const SG_FREIGHT: string = 'SGFRGT';
export const LIEBEN: string = 'LIEBEN';
export const SG_MOB: string = 'SGMOB';
export const SG_GATEWAY: string = 'SGGATEWAY';
export const LLINER: string = 'LLINER';
export const ALMAYA: string = 'ALMAYA';
